import React from 'react'
import store from 'store'
import { Provider } from 'react-redux'
import TotalPrintsCell from './total_prints_cell'

export default class TotalPrintsCellApp extends React.Component {
  render() {
    return (
      <Provider store={store}>
        <TotalPrintsCell {...this.props}/>
      </Provider>
    )
  }
}
